import React, { Component } from 'react';
import PropTypes from 'prop-types';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var readeryUmd_min = createCommonjsModule(function (module, exports) {
(function (global, factory) {
	module.exports = factory();
}(commonjsGlobal, (function () {
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultChunkSize = 32 * 1024;

function readFromFile(file, dataCb, loadingProgressCb, finishedCb) {
  var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { splitBy: /\r?\n/, encoding: "UTF-8" };
  var chunkSize = arguments[5];

  loadingProgressCb = loadingProgressCb || function () {};
  finishedCb = finishedCb || function () {};
  config = {
    splitBy: config.splitBy || /\r?\n/,
    encoding: config.encoding || "UTF-8"
  };
  chunkSize = chunkSize || defaultChunkSize;

  if (!file) {
    return;
  }

  var chunkReader = new OffsetChunkReaderHandler(dataCb, loadingProgressCb, finishedCb, config);
  chunkReader.readToEnd(file, chunkSize);
}

var index = {
  readFromFile: readFromFile
};

var OffsetChunkReaderHandler = function () {
  function OffsetChunkReaderHandler(dataCb, loadingProgressCb, finishedCb, config) {
    _classCallCheck(this, OffsetChunkReaderHandler);

    this.fileReader = new FileReader();
    this.offset = 0;
    this.lastUnhandledChunkPart = "";

    this.dataCb = dataCb;
    this.loadingProgressCb = loadingProgressCb;
    this.finishedCb = finishedCb;
    this.config = config;

    this.readNextChunk = this.readNextChunk.bind(this);
    this.readLastChunk = this.readLastChunk.bind(this);
  }

  _createClass(OffsetChunkReaderHandler, [{
    key: "readToEnd",
    value: function readToEnd(file, chunkSize) {
      var _this = this;

      this.FILE_SIZE = file.size;

      var i = 0;
      var load = function load() {
        if (_this.FILE_SIZE - i > chunkSize) {
          _this.fileReader.onload = _this.readNextChunk;
          _this.fileReader.onloadend = load;
          i += chunkSize;
        } else {
          _this.fileReader.onload = _this.readLastChunk;
          _this.fileReader.onloadend = null;
        }
        var blob = file.slice(_this.offset, chunkSize + _this.offset);
        _this.fileReader.readAsText(blob);
      };
      load();
    }
  }, {
    key: "readNextChunk",
    value: function readNextChunk(evt) {
      var _this2 = this;

      if (evt.target.error !== null) {
        console.error("Read error: " + evt.target.error);
        this.dataCb(null, new Error("Read error: " + evt.target.error));
        return;
      }
      this.offset += evt.target.result.length;

      var splitted = this.lastUnhandledChunkPart.concat(evt.target.result).split(this.config.splitBy);

      this.lastUnhandledChunkPart = splitted.pop();

      splitted.forEach(function (d) {
        _this2.dataCb(d);
      });
      this.loadingProgressCb(this.offset / this.FILE_SIZE * 100);
    }
  }, {
    key: "readLastChunk",
    value: function readLastChunk(evt) {
      var _this3 = this;

      var splitted = this.lastUnhandledChunkPart.concat(evt.target.result).split(this.config.splitBy);

      splitted.forEach(function (d) {
        return _this3.dataCb(d);
      });
      this.loadingProgressCb(100);
      this.finishedCb();
    }
  }]);

  return OffsetChunkReaderHandler;
}();

return index;

})));

});

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_react-file-load-btn__2MRiR {\n  background-color: #007bff;\n\n  color: #fff;\n  border-color: #007bff;\n  cursor: pointer;\n\n  display: inline-block;\n  width: 100%;\n\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s;\n\n  margin: 0;\n  text-transform: none;\n  box-sizing: border-box;\n  text-shadow: none;\n}\n\n.styles_react-file-load-btn__2MRiR:hover {\n  background-color: #0069d9;\n  border-color: #0062cc;\n}\n";
var styles = { "react-file-load-btn": "styles_react-file-load-btn__2MRiR" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * @class ReactFileLoad
 */

var ReactFileLoad = function (_Component) {
  inherits(ReactFileLoad, _Component);

  function ReactFileLoad() {
    classCallCheck(this, ReactFileLoad);

    var _this = possibleConstructorReturn(this, (ReactFileLoad.__proto__ || Object.getPrototypeOf(ReactFileLoad)).call(this));

    _this.state = {
      isLoading: false,
      progress: 0
    };

    _this.handleFileChange = function (e) {
      var _this$props = _this.props,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange,
          _this$props$onProgres = _this$props.onProgress,
          onProgress = _this$props$onProgres === undefined ? function () {} : _this$props$onProgres,
          _this$props$onDataChu = _this$props.onDataChunk,
          onDataChunk = _this$props$onDataChu === undefined ? function () {} : _this$props$onDataChu,
          _this$props$onFinishe = _this$props.onFinished,
          onFinished = _this$props$onFinishe === undefined ? function () {} : _this$props$onFinishe,
          readeryConfig = _this$props.readeryConfig,
          _this$props$chunkSize = _this$props.chunkSize,
          chunkSize = _this$props$chunkSize === undefined ? 1024 : _this$props$chunkSize;


      onChange();
      var file = e.target.files[0];
      readeryUmd_min.readFromFile(file, onDataChunk, function (p) {
        _this.setState({ progress: p, isLoading: true });
        onProgress(p);
      }, function () {
        _this.setState({ isLoading: false });
        onFinished();
      }, readeryConfig, chunkSize);
    };

    _this.id = uniqueId_1();
    return _this;
  }

  createClass(ReactFileLoad, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style,
          text = _props.text,
          accept = _props.accept,
          _props$fromColor = _props.fromColor,
          fromColor = _props$fromColor === undefined ? "#007bff" : _props$fromColor,
          _props$toColor = _props.toColor,
          toColor = _props$toColor === undefined ? "#2c5888" : _props$toColor,
          _props$finishedColor = _props.finishedColor,
          finishedColor = _props$finishedColor === undefined ? "#2c5888" : _props$finishedColor;


      var gradientStyle = this.state.progress === 0 ? {} : this.state.progress === 100 ? { background: finishedColor } : {
        background: "linear-gradient(to right, " + toColor + " " + this.state.progress + "%, " + fromColor + " 0%)"
      };
      var cursorStyle = this.state.isLoading ? { cursor: "wait" } : {};

      var classNames = "" + styles["react-file-load-btn"];
      return React.createElement(
        "div",
        null,
        React.createElement(
          "label",
          {
            type: "button",
            htmlFor: this.id,
            className: classNames,
            style: _extends({}, gradientStyle, cursorStyle, style)
          },
          text
        ),
        React.createElement("input", {
          disabled: this.state.isLoading,
          id: this.id,
          onChange: this.handleFileChange,
          style: { display: "None" },
          type: "file",
          accept: accept
        })
      );
    }
  }]);
  return ReactFileLoad;
}(Component);

ReactFileLoad.propTypes = {
  text: PropTypes.string
};

export default ReactFileLoad;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 87
// module chunks = 0